import type { TeamReportRowType } from '@econtractor/types';
import type { TFunction } from 'i18next';
import type { ReportPeriodType } from '../../ReportDate/periodUtils';
import {
    exportReportWorkbook,
    formatExportPeriod,
    isExportLocalMode,
    moneyColumns,
    roundExportMoney,
    type ExportCell,
} from '../../helper/exportReportWorkbook';

export interface ExportTeamName {
    ID: number;
    teamName: string;
}

export interface ExportTeamsReportParams {
    teams: TeamReportRowType[];
    teamNames: ExportTeamName[];
    dates: [number, number] | null;
    period: ReportPeriodType;
    rate: number;
    t: TFunction;
}

export const exportTeamsReport = async ({
    teams,
    teamNames,
    dates,
    period,
    rate,
    t,
}: ExportTeamsReportParams): Promise<boolean> => {
    if (!teams.length) return false;

    const localMode = isExportLocalMode(rate);
    const title = t('common:SideBarUl.itemRepostsTeams');
    const rows = teams.map((team) => {
        const dirTeam = teamNames.find((item) => Number(item.ID) === Number(team.teamId));
        const row: Record<string, ExportCell> = {
            name: dirTeam?.teamName || '',
            income: roundExportMoney(team.amount),
        };
        if (!localMode) row.incomeLocal = roundExportMoney(team.amountRate);
        return row;
    });

    await exportReportWorkbook({
        filePrefix: 'report-teams',
        sheetName: title,
        title,
        headerLines: [
            { label: t('export.period'), value: formatExportPeriod(t(`dateFilter.${period}`), dates) },
        ],
        columns: [
            { key: 'name', header: t('teamsFields.name'), width: 36 },
            ...moneyColumns('income', 'incomeLocal', t('teamsFields.income'), rate),
        ],
        rows,
        totalLabel: t('export.total'),
    });

    return true;
};
